import { ReactNode } from "react";
import { baseCardStyles } from "./BaseCardStyles";

interface BaseCardProps {
  children?: ReactNode;
}

const BaseCard = (props: BaseCardProps) => {
  return (
    <div className="qag-root">
      <style>{baseCardStyles}</style>
      <div className="qag-card">
        <div className="qag-inner">{props.children}</div>
      </div>
    </div>
  );
};

export default BaseCard;
